import BaseSimidCreative from './base_simid_creative'
import {CreativeMessage} from './simid_protocol'

class SimidSurvey extends BaseSimidCreative {
  constructor(store) {
    super();

    this.callback = null;
  }

  /** @override */
  onStart(eventData) {
    super.onStart(eventData);
    const data = JSON.parse(this.creativeData.adParameters);
    this.callback && this.callback(data)
  }

  ready() {
    const promise = new Promise((resolve, reject) => {
      this.callback = (data) => resolve(data)
    })
    super.ready()
    return promise
  }

  isSkippable() {
    return this.environmentData.skippableState === "adHandles"
  }

  close() {
    if (this.isSkippable()) {
      this.simidProtocol.sendMessage(CreativeMessage.REQUEST_SKIP);
    }
  }
}

let survey = new SimidSurvey()
export default survey
